<template>
  <div class="view-chat">
    <div id="chat-widget-container"></div>
  </div>
</template>

<script>
export default {
  mounted() {
    // Função para gerar um ID único de sessão
    function generateSessionId() {
      return (
        "session_" +
        Date.now() +
        "_" +
        Math.random()
          .toString(36)
          .substr(2, 9)
      );
    }

    // Verificar se é dispositivo móvel
    const isMobile = window.innerWidth <= 480;

    // Criar ou recuperar o ID da sessão
    if (!sessionStorage.getItem("chatSessionId")) {
      sessionStorage.setItem("chatSessionId", generateSessionId());
    }

    // Criar o container do chat se não existir
    if (!document.getElementById("chat-widget-container")) {
      const container = document.createElement("div");
      container.id = "chat-widget-container";
      document.body.appendChild(container);
    }

    // Template HTML do chat
    const chatTemplate = `
  <div class="chat-bubble">
    <svg width="24" height="24" viewBox="0 0 24 24" fill="white">
      <path d="M20 2H4c-1.1 0-2 .9-2 2v18l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2z"/>
    </svg>
  </div>
  <div class="chat-window">
    <div class="chat-header">
      <span>Tutor GW</span>
      <button class="close-btn" title="Fechar">×</button>
    </div>
    <div class="chat-messages"></div>
    <div class="chat-input-container">
      <input type="text" class="chat-input" placeholder="Digite sua mensagem...">
      <button class="send-btn" title="Enviar">
        <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
          <path d="M2.01 21L23 12 2.01 3 2 10l15 2-15 2z"/>
        </svg>
      </button>
    </div>
  </div>
`;

    document.getElementById("chat-widget-container").innerHTML = chatTemplate;

    const webhookUrl =
      "https://paretogroup.app.n8n.cloud/webhook/chatFMA24122024V2";
    let chatHistory = [];

    async function sendMessage(message) {
      const container = document.getElementById("chat-widget-container");
      const messagesContainer = container.querySelector(".chat-messages");
      const sessionId = sessionStorage.getItem("chatSessionId");

      chatHistory.push({ role: "user", content: message });

      const userMessageElement = document.createElement("div");
      userMessageElement.className = "message user-message";
      userMessageElement.textContent = message;
      messagesContainer.appendChild(userMessageElement);

      const typingIndicator = document.createElement("div");
      typingIndicator.className = "typing-indicator";
      typingIndicator.textContent = "Digitando";
      messagesContainer.appendChild(typingIndicator);

      smoothScrollToBottom(messagesContainer);

      try {
        const payload = {
          messages: [{ role: "user", content: message }],
          sessionId: sessionId,
          model: "gpt-3.5-turbo"
        };

        const response = await fetch(webhookUrl, {
          method: "POST",
          headers: {
            "Content-Type": "application/json"
          },
          body: JSON.stringify(payload)
        });

        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }

        const data = await response.json();
        const responseData = Array.isArray(data) ? data[0] : data;

        if (responseData && responseData.output) {
          typingIndicator.remove();

          chatHistory.push({ role: "assistant", content: responseData.output });

          const botMessageElement = document.createElement("div");
          botMessageElement.className = "message bot-message";
          botMessageElement.textContent = responseData.output;
          messagesContainer.appendChild(botMessageElement);

          sessionStorage.setItem(
            "chatHistory_" + sessionId,
            JSON.stringify(chatHistory)
          );
        } else {
          throw new Error("Formato de resposta inesperado");
        }
      } catch (error) {
        // console.error("Erro:", error);

        const existingIndicator = messagesContainer.querySelector(
          ".typing-indicator"
        );
        if (existingIndicator) {
          existingIndicator.remove();
        }

        const errorMessage = document.createElement("div");
        errorMessage.className = "message bot-message";
        errorMessage.textContent =
          "Não foi possível obter uma resposta. Por favor, tente novamente.";
        messagesContainer.appendChild(errorMessage);
      }

      smoothScrollToBottom(messagesContainer);
    }

    function smoothScrollToBottom(element) {
      const isSmoothScrollSupported =
        "scrollBehavior" in document.documentElement.style;

      if (isSmoothScrollSupported) {
        element.scrollTop = element.scrollHeight;
      } else {
        element.scrollTo({
          top: element.scrollHeight,
          behavior: "smooth"
        });
      }
    }

    function loadChatHistory() {
      const sessionId = sessionStorage.getItem("chatSessionId");
      const savedHistory = sessionStorage.getItem("chatHistory_" + sessionId);

      if (savedHistory) {
        chatHistory = JSON.parse(savedHistory);
        const messagesContainer = document.querySelector(".chat-messages");
        messagesContainer.innerHTML = "";

        chatHistory.forEach(msg => {
          const messageElement = document.createElement("div");
          messageElement.className = `message ${
            msg.role === "user" ? "user-message" : "bot-message"
          }`;
          messageElement.textContent = msg.content;
          messagesContainer.appendChild(messageElement);
        });

        smoothScrollToBottom(messagesContainer);
      }
    }

    // Ajuste dinâmico do tamanho da janela
    window.addEventListener("resize", () => {
      const chatWindow = document.querySelector(".chat-window");
      if (chatWindow) {
        if (window.innerWidth <= 480) {
          chatWindow.style.width = "94vw";
          chatWindow.style.right = "3vw";
        } else {
          chatWindow.style.width = "";
          chatWindow.style.right = "";
        }
      }
    });

    function setupEventListeners() {
      const container = document.getElementById("chat-widget-container");
      const bubble = container.querySelector(".chat-bubble");
      const chatWindow = container.querySelector(".chat-window");
      const closeBtn = container.querySelector(".close-btn");
      const input = container.querySelector(".chat-input");
      const sendBtn = container.querySelector(".send-btn");

      bubble.addEventListener("click", () => {
        chatWindow.style.display = "flex";
        bubble.style.display = "none";
        input.focus();
        loadChatHistory();
      });

      closeBtn.addEventListener("click", () => {
        chatWindow.style.display = "none";
        bubble.style.display = "flex";
        input.value = "";
      });

      const handleSendMessage = async () => {
        const message = input.value.trim();
        if (message) {
          input.value = "";
          await sendMessage(message);
        }
      };

      input.addEventListener("keypress", async e => {
        if (e.key === "Enter") {
          await handleSendMessage();
        }
      });

      sendBtn.addEventListener("click", handleSendMessage);
    }

    // Inicializar os event listeners
    setupEventListeners();
  }
};
</script>

<style lang="scss">
:root {
  --chat-primary-color: #000000;
  --chat-bg-color: #ffffff;
  --chat-text-color: #000000;
  --chat-shadow: 0 5px 20px rgba(0, 0, 0, 0.15);
  --chat-border-radius: 10px;
}

#chat-widget-container {
  position: fixed;
  bottom: 20px;
  right: 20px;
  z-index: 999999;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen,
    Ubuntu, sans-serif;
}

.chat-bubble {
  position: fixed;
  bottom: 20px;
  right: 20px;
  width: clamp(50px, 8vw, 60px);
  height: clamp(50px, 8vw, 60px);
  background: var(--chat-primary-color);
  border-radius: 50%;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: var(--chat-shadow);
  transition: transform 0.3s ease;
  z-index: 999999;
}

.chat-bubble:hover {
  transform: scale(1.1);
}

.chat-window {
  position: fixed;
  bottom: clamp(80px, 12vh, 100px);
  right: 20px;
  width: clamp(300px, 90vw, 400px);
  height: clamp(400px, 80vh, 600px);
  background: var(--chat-bg-color);
  border-radius: var(--chat-border-radius);
  box-shadow: var(--chat-shadow);
  display: none;
  flex-direction: column;
  overflow: hidden;
  z-index: 999999;
}

.chat-header {
  background: #f0f0f0;
  padding: clamp(10px, 2vh, 20px);
  border-radius: 10px 10px 0 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-weight: bold;
  font-size: clamp(14px, 2vw, 16px);
}

.chat-messages {
  flex: 1;
  overflow-y: auto;
  padding: 15px;
  scroll-behavior: smooth;
  background: #ffffff;
  display: flex;
  flex-direction: column;
}

.chat-input-container {
  padding: clamp(10px, 2vh, 15px);
  border-top: 1px solid #eee;
  background: white;
  display: flex;
  align-items: center;
  gap: 10px;
}

.chat-input {
  flex: 1;
  padding: clamp(8px, 1.5vh, 12px);
  border: 1px solid #ddd;
  border-radius: 20px;
  font-size: clamp(14px, 1.5vw, 16px);
  outline: none;
  transition: border-color 0.3s;
}

.chat-input:focus {
  border-color: var(--chat-primary-color);
}

.message {
  max-width: 85%;
  padding: 10px 15px;
  border-radius: 15px;
  margin-bottom: 10px;
  font-size: clamp(13px, 1.5vw, 15px);
  line-height: 1.5;
  word-wrap: break-word;
}

.user-message {
  align-self: flex-end;
  background: var(--chat-primary-color);
  color: white;
  border-bottom-right-radius: 5px;
}

.bot-message {
  align-self: flex-start;
  background: #f0f0f0;
  color: var(--chat-text-color);
  border-bottom-left-radius: 5px;
}

.close-btn {
  background: none;
  border: none;
  color: var(--chat-text-color);
  cursor: pointer;
  font-size: 24px;
  padding: 0;
  line-height: 1;
  transition: opacity 0.3s;
}

.close-btn:hover {
  opacity: 0.7;
}

.send-btn {
  width: 40px;
  height: 40px;
  background: var(--chat-primary-color);
  border: none;
  border-radius: 50%;
  color: white;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background-color 0.3s;
}

.send-btn:hover {
  background-color: #333333;
}

.typing-indicator {
  padding: 10px 15px;
  background: #f0f0f0;
  border-radius: 15px;
  margin-bottom: 10px;
  align-self: flex-start;
  font-size: clamp(13px, 1.5vw, 15px);
  color: #666;
}

.typing-indicator::after {
  content: "...";
  animation: typing 1.5s infinite;
}

@keyframes typing {
  0% {
    content: ".";
  }
  33% {
    content: "..";
  }
  66% {
    content: "...";
  }
}

.chat-messages::-webkit-scrollbar {
  width: 6px;
}

.chat-messages::-webkit-scrollbar-track {
  background: #f1f1f1;
}

.chat-messages::-webkit-scrollbar-thumb {
  background: #888;
  border-radius: 3px;
}

.chat-messages::-webkit-scrollbar-thumb:hover {
  background: #555;
}

@media (max-width: 480px) {
  .chat-window {
    width: 94vw;
    height: 85vh;
    right: 3vw;
    bottom: 70px;
  }

  .chat-bubble {
    right: 10px;
    bottom: 10px;
    width: 50px;
    height: 50px;
  }

  .message {
    max-width: 90%;
  }
}

@media (max-height: 500px) {
  .chat-window {
    height: 90vh;
    bottom: 60px;
  }
}

@media (min-width: 1200px) {
  .chat-window {
    width: 400px;
    right: 30px;
  }
}

@media (prefers-reduced-motion: reduce) {
  .chat-bubble,
  .chat-window {
    transition: none;
  }
}
</style>
